import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
export var NotImplementedError = /*#__PURE__*/function (_Error) {
  _inherits(NotImplementedError, _Error);

  var _super = _createSuper(NotImplementedError);

  function NotImplementedError() {
    var _this;

    _classCallCheck(this, NotImplementedError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.message = process.env.NODE_ENV === 'production' ?
    /* istanbul ignore next */
    'Not Implemented' : 'Not Implemented. You must provide an override for this method.';
    return _this;
  }

  return _createClass(NotImplementedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));